{
    "ReportPortalInfo_UpgradeTo_Enterprise": "Aktualisieren Sie auf Enterprise, um auf diese Funktion zuzugreifen",
    "ReportPortalInfo_UpgradeTo_Enterprise_MST": "Aktualisieren Sie auf CXA Advanced (Historisch), um auf diese Funktion zuzugreifen",
    "ReportPortalInfo_UpgradeTo_Call Centre Supervisor": "Aktualisieren Sie auf Call Centre Supervisor, um auf diese Funktion zuzugreifen.",
    "ReportPortalInfo_UpgradeTo_Call Centre Supervisor_MST": "Aktualisieren Sie auf CXA Advanced, um auf diese Funktion zuzugreifen",
    "NAME": "ReportPortalInfo"
}